import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../core'
import * as capitalProjects from '../../capital-projects'

export const RESOURCE = {
  payload: {
    description:
      'A long-term infrastructure investment, such as a building or renovation.',
    dimension: capitalProjects.RESOURCE.payload,
    level: 0,
    name: 'Capital Project',
    partialId: PartialId.Standard.create('cap_proj'),
  },
  type: core.quiver.Resource.Type.DmsEntity,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEntity>

export const MODEL_ID = core.dms.models.Entity.Id.from({
  context: core.dms.models.Entity.Id.Context.from(RESOURCE.payload.dimension),
  partialId: RESOURCE.payload.partialId,
})
